module.exports = __webpack_public_path__ + "media/images/navigation/videos-hover-6fb3c7b58d36ad64cf67965f6e9c234c.gif";